import _ from 'lodash';
import { Box, Stack, Typography } from '@mui/material';

// mui table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import FormLabel from '../../common/form/FormLabel';
import { getNumberComma } from '../../../utils/numberUtils';

const SalesProfitInfo = ({ orderInfo, project }) => {
  //매출이익 - 내부거래비용-예상영업비용=최종매출이익
  // const totalAmt =
  //   Number(orderInfo?.roProfitAmt) -
  //   Number(orderInfo?.roCostAmt) -
  //   Number(orderInfo?.roInternalAmt);

  console.log(JSON.stringify(orderInfo), null, 2);
  const getPercent = (newValue) => {
    const totalSales = project?.totalSales; //매출액
    const numberValue = Number(newValue);
    const percent = Math.round((numberValue / totalSales) * 100);
    return percent;
  };

  const renderRoProfitPercent = orderInfo?.roProfitAmtPercent
    ? orderInfo?.roProfitAmtPercent
    : getPercent(orderInfo?.roProfitAmt);

  const renderRoCostPercent = orderInfo?.roCostAmtPercent
    ? orderInfo?.roCostAmtPercent
    : getPercent(orderInfo?.roCostAmt);

  const roInternalCosts = orderInfo?.roInternalCosts
    ? orderInfo.roInternalCosts
    : orderInfo?.roPartnerUsrUuid
    ? [
        {
          roPartnerUsrUuid: orderInfo?.roPartnerUsrUuid,
          roPartnerUsrNm: orderInfo?.roPartnerUsrNm,
          roInternalAmt: orderInfo?.roInternalAmt,
          roInternalAmtPercent: getPercent(orderInfo?.roInternalAmt),
        },
      ]
    : null;

  const totalInteralAmt = _.sumBy(roInternalCosts, 'roInternalAmt');
  const roAdjProfitAmt =
    Number(orderInfo?.roProfitAmt) -
    Number(orderInfo?.roCostAmt) -
    Number(totalInteralAmt);

  const renderRoAdjProfitAmt = orderInfo?.roAdjProfitAmtPercent
    ? orderInfo?.roAdjProfitAmtPercent
    : getPercent(roAdjProfitAmt);

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Box sx={{ width: '180px' }} textAlign="center">
            <FormLabel sx={{ px: 1 }}>매출이익</FormLabel>
          </Box>
          <Box>{getNumberComma(orderInfo?.roProfitAmt)}</Box>
          <Box>({getNumberComma(renderRoProfitPercent)}%)</Box>
        </Stack>

        <Stack spacing={1}>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{
              py: 1,
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Box sx={{ width: 180 }} textAlign="center">
              <FormLabel sx={{ px: 1 }}>내부거래비용</FormLabel>
            </Box>
            {!roInternalCosts && (
              <Box>
                <Typography variant="subtitle2">
                  등록된 내부 거래비용이 없습니다.
                </Typography>
              </Box>
            )}
          </Stack>
          {roInternalCosts && (
            <TableContainer component={Box} sx={{ px: 3 }}>
              <Table
                sx={{ minWidth: 650 }}
                aria-label="simple table"
                size="small"
              >
                <TableHead>
                  <TableRow>
                    <TableCell align="center">협업본부 영업담당</TableCell>
                    <TableCell align="center">거래비용</TableCell>
                    <TableCell align="center">매출액의%</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {roInternalCosts.map((row) => (
                    <TableRow key={row?.roPartnerUsrUuid}>
                      <TableCell align="center">
                        {row?.roPartnerUsrNm}
                      </TableCell>
                      <TableCell align="center">
                        {getNumberComma(row?.roInternalAmt)}
                      </TableCell>
                      <TableCell align="center">
                        {getNumberComma(row?.roInternalAmtPercent)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Box sx={{ width: '180px' }} textAlign="center">
            <FormLabel sx={{ px: 1 }}>영업비용</FormLabel>
          </Box>
          <Box>{getNumberComma(orderInfo?.roCostAmt)}</Box>
          <Box>({getNumberComma(renderRoCostPercent)}%)</Box>
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            py: 1.5,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            backgroundColor: '#fafafa',
            borderRadius: 1,
            px: 1,
          }}
        >
          <Box sx={{ width: '180px' }} textAlign="center">
            <FormLabel sx={{ px: 1, fontWeight: 700 }}>최종매출이익</FormLabel>
          </Box>
          <Box
            sx={{
              fontSize: '1.1rem',
              fontWeight: 700,
              color: Number(orderInfo?.roAdjProfitAmt) >= 0 ? '#1976d2' : '#d32f2f',
            }}
          >
            {getNumberComma(orderInfo?.roAdjProfitAmt)}
          </Box>
          <Box
            sx={{
              fontSize: '0.9rem',
              color: Number(orderInfo?.roAdjProfitAmt) >= 0 ? '#1976d2' : '#d32f2f',
            }}
          >
            ({getNumberComma(renderRoAdjProfitAmt)}%)
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};

export default SalesProfitInfo;
